
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const FormikCheckbox = props => {

  const {
    label= "",
    name = "",
    formik
  } = props


  return(
    <FormControlLabel 

      label= {label}
      control={
        <Checkbox

          {...props}
          {...formik.getFieldProps(name)}
          checked = {formik.values[name]}
        />
      }

    />
  )
}

export default FormikCheckbox;